import React from 'react'

const Card = () => {
  return (
    <div className='review-card-content'>
        <p>“I love the coffee here! It's so good and the staff is very friendly. I would definitely recommend this place to anyone who loves coffee!”</p>
        <h4>John Doe</h4>
    </div>
  )
}

export default Card